/** Response shapes the screens read. Mirrors apps/api/src/routes. */

import type { MetricKey } from '@pp/shared';

export type Gender = 'female' | 'male' | 'other';

export interface StudentListItem {
  id: string;
  firstName: string;
  lastName: string;
  age: number | null;
  gender: Gender;
  heightCm: number;
  currentWeightKg: number;
  bmi: number | null;
  profilePhotoUrl: string | null;
  lastMeasurementDate: string | null;
  status: 'active' | 'archived';
}

export interface StudentListResponse {
  items: StudentListItem[];
  pagination: { limit: number; offset: number; total: number };
}

export interface StudentMetric {
  key: MetricKey;
  label: string;
  unit: string;
  decimals: number;
  currentValue: number;
  currentDate: string;
  previousValue: number | null;
  previousDate: string | null;
  changeAbs: number | null;
  blockedReason: string | null;
}

export interface StudentOverview {
  id: string;
  firstName: string;
  lastName: string;
  age: number | null;
  gender: Gender;
  dateOfBirth: string;
  heightCm: number;
  currentWeightKg: number;
  bmi: number | null;
  profilePhotoUrl: string | null;
  status: 'active' | 'archived';
  lastMeasurementDate: string | null;
  lastReportDate: string | null;
  metrics: StudentMetric[];
}

export interface MeasurementItem {
  id: string;
  measuredAt: string;
  weightKg: number | null;
  waistCm: number | null;
  hipCm: number | null;
  chestCm: number | null;
  rightArmCm: number | null;
  leftArmCm: number | null;
  rightThighCm: number | null;
  leftThighCm: number | null;
  bodyFatPct: number | null;
  muscle: { value: number; unit: 'percent' | 'kg' } | null;
  /** Measurements the product does not name, in the instructor's own words. */
  custom?: { label: string; labelNormalized: string; unit: string; value: number }[];
  createdAt: string;
}

export interface MeasurementListResponse {
  items: MeasurementItem[];
}

export interface DashboardResponse {
  activeStudents: number;
  reportsThisMonth: number;
  serverDate: string;
}

export const GENDER_LABELS: Record<Gender, string> = {
  female: 'Kadın',
  male: 'Erkek',
  other: 'Diğer',
};
